import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { useNavigate } from "react-router-dom";
import { useTickets } from "./TicketContext";

dayjs.extend(advancedFormat);

export default function Calendar() {
  const [currentMonth, setCurrentMonth] = useState(dayjs().month(3).startOf("month"));
  const [selectedDate, setSelectedDate] = useState(null);

  const daysInMonth = currentMonth.daysInMonth();
  const firstDayOfMonth = currentMonth.startOf("month").day();
  const today = dayjs();

  const prevMonth = () => {
    setCurrentMonth((prev) => prev.subtract(1, "month"));
    setSelectedDate(null);
  };

  const nextMonth = () => {
    setCurrentMonth((prev) => prev.add(1, "month"));
    setSelectedDate(null);
  };

  const getDayType = (date) => {
    return date.date() % 7 === 0 || date.date() % 6 === 0 ? "peak" : "regular";
  };

  const { tickets, setTickets, totalTickets, totalPrice } = useTickets();

  const navigate = useNavigate();

  return (
    <>

    
    <div className="flex flex-col items-center justify-center p-4 pb-24 bg-[#f8f5eb] min-h-screen">
        <p className="w-full px-6 mb-5 text-2xl font-semibold text-green-900 md:px-52 text-start font-georgia">Select your date of visit</p>




      <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2 md:px-44">

      <div className="relative w-full p-4 bg-white rounded-2xl">
        <div className="flex items-center justify-between pb-3 mb-3 border-b">
          <button onClick={prevMonth} className="p-3 bg-yellow-400 rounded-full shadow">
            <ChevronLeft size={16} />
          </button>
          <h2 className="text-lg font-bold text-green-900">{currentMonth.format("MMMM YYYY")}</h2>
          <button onClick={nextMonth} className="p-3 bg-yellow-400 rounded-full shadow">
            <ChevronRight size={16} />
          </button>
        </div>

        <div className="grid grid-cols-7 gap-1 text-sm font-semibold text-center">
          {["M", "T", "W", "T", "F", "S", "S"].map((day, index) => (
            <div key={index} className="text-gray-700">{day}</div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-2 mt-2">
          {[...Array(firstDayOfMonth)].map((_, index) => (
            <div key={`empty-${index}`} className="p-4"></div>
          ))}
          {[...Array(daysInMonth)].map((_, index) => {
            const date = currentMonth.date(index + 1);
            const isToday = date.isSame(today, "day");
            const isPast = date.isBefore(today, "day");
            const dayType = getDayType(date);
            const isSelected = selectedDate && date.isSame(selectedDate, "day");

            return (
              <div
                key={index}
                onClick={() => !isPast && setSelectedDate(date)}
                className={`p-2 text-center  w-full h-20 flex flex-col   justify-center items-center transition cursor-pointer text-lg md:text-2xl  ${
                  isToday ? "bg-[#999999] text-white" : 
                  isPast ? "bg-[#EEEEEE] text-neutral-400 cursor-not-allowed" : 
                  isSelected ? "bg-[#333333] text-white" : "bg-[#f8f5ee] text-black"
                }`}
              >
                <span className="font-semibold">{index + 1}</span>
                {!isPast && <span className={`text-[10px] md:text-xs ${
                  isToday ? " text-white" : 
                  isPast ? " text-neutral-400 cursor-not-allowed" : 
                  isSelected ? " text-white" : " text-black"
                }`}>${totalPrice}.00</span>}
                {!isPast && dayType === "regular" && <div className="w-full h-1 mt-1 bg-green-600"></div>}
                {!isPast && dayType === "peak" && <div className="w-full h-1 mt-1 bg-orange-500"></div>}
              </div>
            );
          })}
        </div>

        <div className="flex flex-col justify-start mt-6 md:space-x-12 md:flex-row">
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-green-600 rounded"></div>
            <span className="text-gray-700 ">Regular</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-orange-500 rounded"></div>
            <span className="text-gray-700 ">Peak</span>
          </div>
        </div>

        {selectedDate && (
          <div className="mt-3 text-lg font-bold text-center text-green-900">
            Selected Date: {selectedDate.format("MMMM D, YYYY")}
          </div>
        )}
      </div>

      <div className="w-full max-w-md p-6 mt-4 mb-10 bg-white md:ml-10 md:mt-0 h-fit rounded-2xl">
        <h2 className="mb-5 text-xl font-bold text-green-900 font-georgia">Total Payable</h2>
        <p className="font-bold text-gray-900 text-md font-georgia">S${totalPrice}.00</p>
        <p className="text-gray-600 text-md font-georgia">Inclusive of 9% GST S$ 3.55</p>
        <div className="pt-3 mt-3 border-t">
          <h3 className="mt-5 font-bold text-green-900 text-md font-georgia">Admissions</h3>
          <p className="text-gray-700 text-md font-georgia">Rainforest Wild ASIA Admission</p>
          <div className="flex justify-between mt-2 font-semibold text-md font-georgia">
            <span>Adult (Non-resident)</span>
            <span>x {totalTickets}</span>
            <span>S${totalPrice}.00</span>
          </div>
        </div>
      </div>

       

      </div>




 


      <div className="fixed bottom-0 flex justify-end w-full p-4 mt-4 bg-white">
        <button
          onClick={() => navigate(-1)}
          className="mr-10 text-gray-700 text-md font-georgia hover:underline"
        >
          Back
        </button>
        <button
          onClick={() => navigate("/3")}
          disabled={!selectedDate}
          className={`px-6 py-2 text-white text-md font-georgia font-bold rounded-full shadow   ${
            selectedDate ? "bg-black" : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          NEXT
        </button>


        
      </div>

    </div>
    </>

  );
}
